import React, { FC, useContext } from 'react';
import { DATES } from '../../../constants/StoreConstants';
import { FormValuesContext } from '../../index.contexts';

const UnknownFields: FC<Record<string, unknown>> = () => {
  const { formValues } = useContext(FormValuesContext);
  const datesValues = formValues?.[DATES] ?? {};
  const { flexible } = datesValues;
  return (
    <>
      <input type="hidden" name="isInternalSearch" value="true" />
      <input type="hidden" name="vsInitialRequest" value="false" />
      <input type="hidden" name="searchType" value="InCity" className="js-searchtype" />
      <input type="hidden" name="for-hotels-nearme" value="Near" className="for-hotels-nearme" />
      <input type="hidden" name="collapseAccordian" value="is-hidden" />
      <input type="hidden" name="singleSearch" value="true" />
      <input type="hidden" name="roomTypeCode" value="" />

      <input
        type="hidden"
        name="autoSuggestItemType"
        value=""
        className="autosuggest-item-type js-autosuggest-item-type"
      />

      <input type="hidden" name="propertyCode" value="" className="search-property-code" />
      <input type="hidden" name="destinationAddress.stateProvinceShort" value="" />

      <input type="hidden" name="destinationAddress.cityPopulation" value="" className="city-pop" />
      <input type="hidden" name="destinationAddress.locality" value="" />
      <input type="hidden" name="showAddressPin" value="" className="show-address-pin" />

      <input
        type="hidden"
        name="destinationAddress.stateProvinceDisplayName"
        value=""
        className="search-state-province"
      />
      <input type="hidden" name="destinationAddress.destinationPageDestinationAddress" value="" />
      <input type="hidden" name="countryName" value="" className="search-country-name" />
      <input type="hidden" name="singleSearchAutoSuggest" value="Unmatched" className="single-search-autosuggest" />
      <input type="hidden" name="airportName" value="" className="search-airport-name" />
      <input type="hidden" name="suggestionsPropertyCode" value="" />
      <input type="hidden" name="destinationAddress.name" value="" />
      <input type="hidden" name="poiCity" value="" className="js-search-city-display" />
      <input type="hidden" name="destinationAddress.countryShort" value="" />
      <input type="hidden" name="poiName" value="" className="search-poiname" />
      <input type="hidden" name="search-countryRegion" value="" />
      <input type="hidden" name="destinationAddress.cityPopulationDensity" value="" className="city-pop-density" />
      <input type="hidden" name="airportCode" value="" className="search-airport js-search-airport" />
      <input type="hidden" name="search-locality" value="" />
      <input type="hidden" name="roomTypeCode" value="" />
      <input type="hidden" name="propertyCode" value="" className="search-property-code" />
      <input type="hidden" name="flexibleDateSearchRateDisplay" value="false" />
      <input type="hidden" name="propertyName" value="" className="search-property-name" />
      <input type="hidden" name="isSearch" value="true" />
      <input type="hidden" name="marriottRewardsNumber" value="" />
      <input type="hidden" name="isRateCalendar" value={flexible ? 'true' : 'false'} />
      <input type="hidden" name="incentiveType_Number" value="" />
      <input type="hidden" name="incentiveType" value="" />
      <input type="hidden" name="flexibleDateLowestRateMonth" value="" />
      <input type="hidden" name="flexibleDateLowestRateDate" value="" />
      <input type="hidden" name="isMultiRateSearch" value="" />
      <input type="hidden" name="multiRateMaxCount" value="" />
      <input type="hidden" name="multiRateCorpCodes" value="" />
      <input type="hidden" name="useMultiRateRewardsPoints" value="" />
      <input type="hidden" name="multiRateClusterCodes" value="" />
      <input type="hidden" name="multiRateCorpCodesEntered" value="" />
      <input type="hidden" name="lowestRegularRate" value="" />

      {/* These input does not have name. Hoping they are useless */}
      {/*
          <input type="hidden" value="Guests/room" className="single-search-guest-count-label" />
          <input type="hidden" id="checkout-reset-date" value="" />
          <input type="hidden" id="checkin-reset-date" value="" />
          <input type="hidden" value="" className="search-adminDistrict" />
          <input type="hidden" value="" className="single-search-type" />
          <input type="hidden" value="Rooms" className="single-search-room-count-label" />
          <input type="hidden" value="" />
          <input type="hidden" value="" />
          <input type="hidden" value="" />
          <input type="hidden" value="MM/dd/yy" className="single-search-date-format" />
          <input
            type="hidden"
            className="autosuggest-cat-headers"
            data-category-params='{"recent":"Recent", "clear":"Clear Recent", "city":"CITIES", "property": "Hotel", "state": "STATES", "country":"COUNTRIES/REGIONS", "airport":"AIRPORTS", "poi":"POINTS OF INTEREST", "label":"Continue typing to narrow your results", "searchResults":"Search Results", "currentLocation":"Current Location", "recentlyViewedLabel": "Recently Viewed", "recentSearchesLabel": "Recent Searches", "clearRecentLabel": "CLEAR RECENT", "showMoreLabel": "SHOW MORE", "showLessLabel": "SHOW LESS",  "showRecentlyViewedProperties": true, "minRecentlyViewedPropertiesLimit": 2, "maxRecentlyViewedPropertiesLimit": 5, "expandedLabel": "expanded", "collapsedLabel": "collapsed" }'
          />
          <input
            type="hidden"
            className="search-google-map"
            name=""
            data-options='{"api":"//maps.googleapis.com/maps/api/js?v=3.exp&amp;client=gme-marriottinternational&amp;libraries=places,geometry&amp;signed_in=false&amp;region=", "language": "en"}'
          />
        */}

      {/* This does not have a value attribute. Not sure of it's funcationality */}
      {/* <input
          type="hidden"
          name="js-location-nearme-values"
          className="js-location-nearme-values"
          data-triggertitle="Use my current location"
          data-errhead="Nearby Hotel Request"
          data-errmessage="No location available"
          data-radius="50"
          data-bingkey="AtiQIdR6T0kGOCP2ZVCZXXGTaTgVLLvfGBnUUkd1jQhHse_G6NIh8zjvASLdjAgm"
          data-binglocation="dev.virtualearth.net/REST/v1/Locations/"
          data-title="Current Location"
          data-neartext="Near"
          data-error-popup-button-text="Ok"
        /> */}
    </>
  );
};

export default UnknownFields;
